import AppCheckboxInput from './AppCheckboxInput';

export default AppCheckboxInput;